export const VariantsWithClear = ['GreyOutlinedClear', 'GreyOutlinedPillClear'];
//# sourceMappingURL=BKJSelect.constants.js.map